<app-asset-listing-page
  [headerConfig]="headerConfig"
  [filterConfig]="filterConfig"
            [assets]="models"
            assetType="model"
            searchPlaceholder="Search for models"
  filterSearchPlaceholder="Search for models"
  [searchQuery]="searchQuery"
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [viewMode]="viewMode"
            [itemsPerPage]="itemsPerPage"
  [showMobileFilterButton]="true"
  [isMobileFilterOpen]="isMobileFilterOpen"
  [isLoggedIn]="isLoggedIn"
  (filterChange)="onFilterChange($event)"
  (resetFilters)="onResetFilters()"
  (filterSectionExpandChange)="onFilterSectionExpandChange()"
  (searchChange)="onSearchChange($event)"
            (pageChange)="onPageChange($event)"
            (viewModeChange)="onViewModeChange($event)"
            (itemsPerPageChange)="onItemsPerPageChange($event)"
  (openMobileFilter)="openMobileFilter()"
  (closeMobileFilter)="closeMobileFilter()"
  [sortOption]="sortOption"
  [initialCollectionTab]="collectionTab"
  (sortChange)="onSortChange($event)"
  (collectionTabChange)="onCollectionTabChange($event)"
  (bookmarksClick)="onBookmarksClick()"
  (likeClick)="onLikeClick()"
></app-asset-listing-page>

<!-- Login Modal -->
<app-login-modal *ngIf="showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>

